<br /><br />
<div class="main-title-ds">
  <!-- <h3 class="small-title text-center">Our Team</h3> -->
  <h2 class="title text-center">Our Management</h2>
</div>
<br />
<div class="director">
  <!-- <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-md-8 col-lg-6">
        <div class="header-section">
           <h2 class="title">Our Management</h2>
        </div>
      </div>
    </div>
  </div> -->

  <div class="people">
    <div class="card">
      <div class="card-body">
        <h6 class="card-subtitle mb-2">President</h6>
        <h4 class="card-title">Suresh Kumar Veerabadran</h4>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h6 class="card-subtitle mb-2">Secretary</h6>
        <h4 class="card-title">Jey Ramachandran</h4>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h6 class="card-subtitle mb-2">Treasurer</h6>
        <h4 class="card-title">Vishnu Kumaran Kamatchi Viswanaathan</h4>
      </div>
    </div>
  </div>
</div>

<br /><br />

<div class="director">
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-md-8 col-lg-6">
        <div class="header-section">
          <h2 class="title">Board of Directors</h2>
        </div>
      </div>
    </div>
  </div>
  <div class="people">
    <div class="card">
      <div class="card-body"><h4 class="card-title">Iyappan Pugalendi</h4></div>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Lakshmikanth Jayaraman</h4>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Sriram kumar Muthuraj Dhanalakshmi</h4>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Sankarapandian Lakshmanan</h4>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Dhanaraman Perumalsamy</h4>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Karthikeyan Thiagarajan</h4>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Subha Nandhini Mani</h4>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Andavar Surulinathan</h4>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Sudharsan Balaji Krishnaraj</h4>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  // .main-title-ds .small-title {
  //   margin-bottom: 25px;
  //   font-size: 16px;
  //   font-weight: 500;
  //   color: #3e64ff;
  // }
  .main-title-ds .title {
    font-weight: 700;
    font-size: 45px;
  }

  .director {
    border: rgb(58, 58, 58) 2px solid;
    margin: 30px;
    width: 90%;
    margin: auto;
    font-family: 'Poppins', sans-serif;
    padding: 10px 0;

    .people {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      @media only screen and (min-width: 651px) and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
      }
      @media only screen and (max-width: 650px) {
        grid-template-columns: 1fr;
      }
    }

    .card {
      margin: 5vh 5%;
      max-width: 90%;
      &:hover {
        background: #fc4a1a; /* fallback for old browsers */
        background: -webkit-linear-gradient(
          to right,
          #f7b733,
          #fc4a1a
        ); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(
          to right,
          #f7b733,
          #fc4a1a
        ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

        .card-title,
        .card-subtitle {
          transition: all 0.3s ease;
          color: #fff;
        }
      }
    }

    .header-section {
      margin-bottom: 20px;
    }

    .card-title {
      margin-bottom: 10px;
      // font-size: 28px;
      font-weight: 700;
      transition: all 0.3s ease;
    }
    .card-subtitle {
      text-transform: uppercase;
      font-size: 14px;
      color: #016cec;
      transition: all 0.3s ease;
    }
  }
</style>
